import { IconName } from '@cbhq/cds-common';
import { Icon } from '@cbhq/cds-web/icons';
import { Box } from '@cbhq/cds-web/layout';
import { CoinbaseProfileMenuResource } from '@cbhq/identity-api-hooks/profile-menu/types';

import { RemoteImage } from '../../NavigationLink/components/RemoteImage';

type ResourceMediaProps = {
  resource: CoinbaseProfileMenuResource;
  small?: boolean;
};

export function ResourceMedia({ resource, small }: ResourceMediaProps) {
  if (resource.logoUrl) {
    return (
      <Box height={small ? '' : '48px'} justifyContent="center" alignItems="center">
        <RemoteImage
          height={small ? 20 : 32}
          width={small ? 20 : 32}
          shape="squircle"
          source={resource.logoUrl}
        />
      </Box>
    );
  }

  return (
    <Box height={small ? '' : '48px'} justifyContent="center" alignItems="center">
      <Icon active={false} name={resource.icon as IconName} size={small ? 's' : 'm'} color="fg" />
    </Box>
  );
}
